import React from "react";

import { Slide, Heading } from "spectacle";
import FunctionView from "../components/FunctionView";
import ComplexPlane from "../components/ComplexPlane";
import animations from "../util/animations";
import "../style.css";
import { cpow, cadd } from "../util/CMath";

class ComplexFunction extends React.Component {
  state = {
    time: 0
  };
  componentDidMount() {
    animations.add(this, {
      key: "time",
      min: 0,
      max: 1,
      length: 30000,
      repeat: true
    });
  }
  componentWillUnmount() {
    animations.remove(this);
  }
  render() {
    const t = 2 * Math.PI * (this.state.time - 0.1);
    const p = [Math.cos(t), Math.sin(t)];
    return (
      <div style={{ position: "relative" }}>
        <ComplexPlane numbers={[p]} xMax={1.6} />
        <div
          style={{
            position: "absolute",
            top: "10%",
            left: "-10%",
            width: "120%"
          }}
        >
          <Heading size={3}>
            <FunctionView
              animated={false}
              complex={true}
              x={p}
              precision={100}
              f={x => cadd([-1, 0], cpow(x, 5))}
            />
          </Heading>
        </div>
      </div>
    );
  }
}

const iSquared = (
  <div
    style={{
      position: "absolute",
      top: "10%",
      right: "8%"
    }}
  >
    <Heading size={2}>
      i<sup>2</sup> = -1
    </Heading>
  </div>
);

const phi = 1.61803398875;
export default [
  <Slide>
    <div style={{ position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: "20%",
          width: "100%"
        }}
      >
        <Heading size={2}>Getallen</Heading>
      </div>
      <ComplexPlane
        numbersAnimated={true}
        imagAxis={false}
        numbers={[[2.71828182846, 0], [-phi, 0]]}
        movingNumbers={[
          t => [0.5 + Math.cos(2 * Math.PI * 2 * t), 0],
          t => [
            (1 - phi + Math.PI / 2) / 2 -
              ((1 - phi - Math.PI / 2) / 2) *
                Math.cos(3 * Math.PI * 2 * (t + 0.1)),
            0
          ]
        ]}
      />
    </div>
  </Slide>,
  <Slide>
    <div style={{ position: "relative" }}>
      <ComplexPlane imagAxis={false} numbers={[[0, 1]]} />
      {iSquared}
    </div>
  </Slide>,
  <Slide>
    <div style={{ position: "relative" }}>
      <ComplexPlane
        imagAnimated={true}
        numbers={[[0, 1, { className: "fadeOut-10" }]]}
      />
      {iSquared}
    </div>
  </Slide>,
  <Slide>
    <div style={{ position: "relative" }}>
      <ComplexPlane
        numbersAnimated={true}
        numbers={[[2.71828182846, 0], [0.8, -1.5]]}
        movingNumbers={[
          t => [
            -1.9 + Math.cos(2 * Math.PI * t),
            1.3 + Math.sin(-2 * Math.PI * t)
          ],
          t => [
            -1.5 + Math.sin(2 * Math.PI * t),
            -1 - 0.8 * Math.cos(2 * Math.PI * t)
          ]
        ]}
      />
      {iSquared}
    </div>
  </Slide> /*
  <Slide>
    <ComplexFunction />
  </Slide> */
];
